<template>

    <div class="play-video-container" :class="{'mobile-play-video-container':isMobile}">
        <div v-if="isMobile && selectedSection.liveStatus !== '2'"
             style="width: 100%;height: 100vh;position: fixed;top: 0;left:0;background: #333333;z-index: -1"></div>

        <div v-if="!isLoadSection && selectedSection.liveStatus !== '2'" class="video-live-title">
            <span>
                <a-icon v-if="isMobile" type="left" style="color: white"
                        @click="$router.replace('/other/course/online/detail/'+courseId)"
                />
                [直播] {{selectedSection.sectionName}}
            </span>
            <span class="open-live-online" v-if="isLiveSwitch">
                <a-button type="primary" size="small" @click="openLiveModal()"
                          v-if="!isLoadSection && selectedSection.liveStatus === '0'">开启直播</a-button>
                <a-button type="danger" size="small" @click="closeLiveModal()"
                          style="background: #f5222d;color: white;border: #f5222d"
                          v-if="!isLoadSection && selectedSection.liveStatus === '1'">关闭直播</a-button>
            </span>
        </div>

        <div class="video">

            <div v-show="isLoadSection" style="width: 860px" :style="isMobile?{height:'180px'}:{}">
                <loading/>
            </div>

            <!--录播课程-->
            <video v-show="!isLoadSection && selectedSection.liveStatus === '2' && selectedSection.isHaveVideo==='1' "
                   controlslist="nodownload"
                   ref='videoRef'
                   class="video-play"
                   controls>
                <source :src="fileUrl">
                您的浏览器不支持 video 标签。
                <div>暂无视频</div>
            </video>

            <div v-if="!isLoadSection && selectedSection.liveStatus === '2' && selectedSection.isHaveVideo!=='1'"
                 class="no-video no-video-live">
                暂无回放视频，敬请期待！
            </div>


            <div v-show="!isLoadSection && selectedSection.liveStatus == '1' && isLive ">
                <div class="prism-player" id="player-con" ref="player"></div>

                <!--                <div class="player-control" >-->
                <!--                    <span> <a-icon type="play-circle"   @click="play" /></span>-->
                <!--                    <span> <a-icon type="pause-circle"  @click="pause" /></span>-->
                <!--                    <span> <a-icon type="redo"          @click="reload" /></span>-->
                <!--                </div>-->
            </div>

            <div v-if="!isLoadSection && selectedSection.liveStatus === '1' &&  !isLive" class="no-video no-video-live">
                <!--                暂无直播内容！-->
                <img :src="selectedSection.liveCoverUrl || liveCoverUrl || defaultCoverUrl" alt="图片"
                     style="display:block; width: 100%;height: 100%">
                <div class="no-video-live-text">{{liveCoverText}}</div>
            </div>

            <div v-if="!isLoadSection && selectedSection.liveStatus === '0' " class="no-video"
                 style="padding-top: 240px">
                老师还未开启直播，敬请期待！
            </div>

        </div>

        <!--直播课-->
        <div v-show="!isMobile && selectedSection.liveStatus === '1'" class="chat-room-container">
            <a-tabs :activeKey="activeKey" @change="changeTab">
                <a-tab-pane tab="讨论" key="1">
                    <div class="discussion" id="logs" ref="discussion">
                        <li v-for="(item,key) in msgList" :key="key" :class="{'logs-li':item.isSystemMsg}">
                            <div v-if="item.isSystemMsg" style="text-align: center;font-size: 12px;min-height: 20px">
                                {{item.msg}}
                            </div>
                            <div v-else>
                                <div v-if="item.type == 1">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="margin-left: 4px;vertical-align:middle;"
                                              :title="item.nickName+'('+item.from+')'"> {{item.nickName}} <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span></span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;text-align:justify;text-justify:distribute-all-lines; word-wrap: break-word; word-break: normal; ">
                                        {{item.content}}
                                    </dt>
                                </div>

                                <div v-else-if="item.type == 2">
                                    <div v-if="item.content == '[[flower]]'"
                                         style="text-align: center;font-size: 12px;">
                                        <span style="margin-right: 8px;color: #1ec5ef">{{item.nickName}}</span> 送出 <img
                                            src="../../../assets/img/live-online/玫瑰花.png" alt="">
                                    </div>
                                    <div v-else-if="item.content == '[[like]]'"
                                         style="text-align: center;font-size: 12px;">
                                        <span style="vertical-align:middle"> <span
                                                style="margin-right: 8px;color: #1ec5ef">{{item.nickName}}</span> 觉得很赞 </span>
                                        <img src="../../../assets/img/live-online/点赞.gif" alt=""
                                             style="width: 24px;vertical-align:bottom">
                                    </div>
                                </div>

                                <div v-else-if="item.type == 3">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="margin-left: 4px;vertical-align:middle;"
                                              :title="item.nickName+'('+item.from+')'"> {{item.nickName}} <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span></span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;text-align:justify;text-justify:distribute-all-lines; ">
                                        <img :src="item.fileUrl" alt=""
                                             style="max-width: 100%;max-height: 300px;cursor: pointer"
                                             @click="openImg(item.fileUrl)">
                                    </dt>
                                </div>

                                <div v-else-if="item.type == 4">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;word-wrap: break-word; word-break: normal; ">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="margin-left: 4px;vertical-align:middle;"
                                              :title="item.nickName+'('+item.from+')'"> {{item.nickName}} <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span></span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;text-align:justify;text-justify:distribute-all-lines; ">
                                        <a :href="item.fileUrl" class="msg-a">
                                            <a-icon type="file" style="color: goldenrod;margin-right: 4px"/>
                                            {{item.fileName}} </a>
                                    </dt>
                                </div>

                            </div>
                        </li>
                    </div>
                </a-tab-pane>
                <a-tab-pane :tab="'成员（'+groupUserList.length+'）'" key="2" forceRender>
                    <div class="member" id="onlinePanel">
                        <ul>
                            <li v-for="item in groupUserList" :key="item.id" style="margin-bottom: 6px">
                                <!--                                {{item.avatar}}-->
                                <a-avatar class="avatar" :size="32" :src=item.avatar
                                          icon="user"/>
                                <span style="margin-left: 10px">  {{item.nick}}</span>

                            </li>
                        </ul>
                    </div>
                </a-tab-pane>
            </a-tabs>
            <div>

            </div>
            <div class="speak">
                <div class="picker" v-show="showPicker">
                    <picker
                            :include="['people']"
                            :showSearch="false"
                            :showPreview="false"
                            :showCategories="false"
                            @select="addEmoji"
                    />
                </div>
                <a-input placeholder="发消息" v-model="content" name="emoji" @keyup.enter="sendMessage(1)"/>
            </div>
            <div class="sendAll">
                <img src="../../../assets/img/live-online/送花.png" alt="" @click="sendMessage(2,'[[flower]]')">
                <img src="../../../assets/img/live-online/点赞.png" alt="" @click="sendMessage(2,'[[like]]')">
                <img src="../../../assets/img/live-online/表情.png" alt="" @click="showPicker=!showPicker">
                <a-upload
                        name="file"
                        action="/api/pc/jim/chatroom/upload/file"
                        :headers="headers"
                        @change="handleChangeImg"
                        :beforeUpload="beforeUpload"
                        :showUploadList="false"
                >
                    <img src="../../../assets/img/live-online/图片.png" alt="">
                </a-upload>
                <a-upload
                        name="file"
                        action="/api/pc/jim/chatroom/upload/file"
                        :headers="headers"
                        @change="handleChangeFile"
                        :beforeUpload="beforeUpload"
                        :showUploadList="false"
                >
                    <img src="../../../assets/img/live-online/文件.png" alt="">
                </a-upload>

                <a-progress :percent="percent" size="small" status="active" class="progress" v-show="showProgress"/>
                <a-button type="primary" style="float: right" @click="sendMessage(1)">发送</a-button>
            </div>
        </div>

        <!--直播结束后，显示章节列表-->
        <div v-if="!isMobile && selectedSection.liveStatus === '2'" class="sections-container">
            <div v-for="(section,sectionNum) in courseInfo.liveCourseSections"
                 :key="section.sectionId">
                <div class="section-title"> {{section.sectionName}}</div>
                <ul>
                    <li v-for="(subSection,subSectionNum) in section.subSections" :key="subSection.sectionId"
                        @click="playVideo(subSection.sectionId,subSection)"
                        v-show="subSection.liveStatus === '2' && subSection.isHaveVideo==='1'"
                        :class="{'active-section':selectedSection.sectionId===subSection.sectionId}">
                        <div class="section-name">
                            <span>回放</span>
                            {{sectionNum+1}}-{{subSectionNum+1}}
                            <span style="margin-left: 5px">
                                {{subSection.sectionName}}
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 移动端样式-->
        <div v-if="isMobile && selectedSection.liveStatus !== '2'" class="sectio-mobile">
            <a-tabs :activeKey="activeKey" @change="changeTab" style="z-index: 1">
                <a-tab-pane tab="讨论" key="1">
                    <div class="discussion-mobile" ref="discussion" :style="{height:discussionHeight}">
                        <li v-for="(item,key) in msgList" :key="key" :class="{'logs-li':item.isSystemMsg}">
                            <div v-if="item.isSystemMsg" style="text-align: center;font-size: 12px;height: 20px">
                                {{item.msg}}
                            </div>
                            <div v-else>

                                <div v-if="item.type == 1">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="vertical-align:middle;" :title="item.nickName+'('+item.from+')'"> {{item.nickName}}   <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span>     </span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;word-wrap: break-word; word-break: normal; ">
                                        {{item.content}}
                                    </dt>
                                </div>
                                <div v-else-if="item.type == 2">
                                    <div v-if="item.content == '[[flower]]'"
                                         style="text-align: center;font-size: 12px;">
                                        <span style="margin-right: 8px;color: #1ec5ef">{{item.nickName}}</span> 送出 <img
                                            src="../../../assets/img/live-online/玫瑰花.png" alt="">
                                    </div>
                                    <div v-else-if="item.content == '[[like]]'"
                                         style="text-align: center;font-size: 12px;">
                                        <span style="vertical-align:middle"> <span
                                                style="margin-right: 8px;color: #1ec5ef">{{item.nickName}}</span> 觉得很赞 </span>
                                        <img src="../../../assets/img/live-online/点赞.gif" alt=""
                                             style="width: 24px;vertical-align:bottom">
                                    </div>
                                </div>
                                <div v-else-if="item.type == 3">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="margin-left: 4px;vertical-align:middle;"
                                              :title="item.nickName+'('+item.from+')'"> {{item.nickName}} <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span></span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;text-align:justify;text-justify:distribute-all-lines; ">
                                        <img :src="item.fileUrl" alt="" style="max-width: 100%;max-height: 300px"
                                             @click="openImg(item.fileUrl)">
                                    </dt>
                                </div>

                                <div v-else-if="item.type == 4">
                                    <dt style="color: #00CF8C;font-size: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        <a-avatar icon="user" class="avatar" :size="22" :src=item.avatar
                                                  style="vertical-align:middle;"/>
                                        <span style="margin-left: 4px;vertical-align:middle;"
                                              :title="item.nickName+'('+item.from+')'"> {{item.nickName}} <span
                                                style="color: #e8e8e8;font-size: 12px">  ({{item.from}})</span></span>
                                    </dt>
                                    <dt style="font-size: 12px;margin:6px 0 10px 0;padding: 0 20px;text-align:justify;text-justify:distribute-all-lines;word-wrap: break-word; word-break: normal;  ">
                                        <a :href="item.fileUrl" class="msg-a">
                                            <a-icon type="file" style="color: goldenrod;margin-right: 2px"/>
                                            {{item.fileName}} </a>
                                    </dt>
                                </div>

                            </div>
                        </li>
                    </div>
                </a-tab-pane>
                <a-tab-pane :tab="'成员（'+groupUserList.length+'）'" key="2" forceRender>
                    <div class="member" :style="{height:discussionHeight}">
                        <ul>
                            <li v-for="item in groupUserList" :key="item.id" style="margin-bottom: 6px">
                                <!--                                {{item.avatar}}-->
                                <a-avatar class="avatar" :size="32" :src=item.avatar
                                          icon="user"/>
                                <span style="margin-left: 10px">  {{item.nick}}</span>
                            </li>
                        </ul>
                    </div>
                </a-tab-pane>
            </a-tabs>

            <div class="sub">
                <div class="phone-picker" v-show="showPhonePicker">
                    <picker
                            :include="['people']"
                            :showSearch="false"
                            :showPreview="false"
                            :showCategories="false"
                            @select="addEmoji"
                    />
                </div>
                <span v-if="showPhoneFlower">
                    <img src="../../../assets/img/live-online/送花.png" alt="" @click="sendMessage(2,'[[flower]]')">
                    <img src="../../../assets/img/live-online/点赞.png" alt="" @click="sendMessage(2,'[[like]]')">
                    <img src="../../../assets/img/live-online/表情.png" alt=""
                         @click="showPhonePicker = !showPhonePicker">
     <a-upload
             name="file"
             action="/api/pc/jim/chatroom/upload/file"
             :headers="headers"
             @change="handleChangeImg"
             :beforeUpload="beforeUpload"
             :showUploadList="false"
     >
                    <img src="../../../assets/img/live-online/图片.png" alt="">
                </a-upload>
                <a-upload
                        name="file"
                        action="/api/pc/jim/chatroom/upload/file"
                        :headers="headers"
                        @change="handleChangeFile"
                        :beforeUpload="beforeUpload"
                        :showUploadList="false"
                >
                    <img src="../../../assets/img/live-online/文件.png" alt="">
                </a-upload>
                </span>
                <a-icon type="menu"
                        @click="showPhoneFlower = !showPhoneFlower ,showPhonePicker = false"/>
            </div>

            <div class="mobile-send-msg">
                <a-input placeholder="发消息" v-model="content"/>
                <a-button type="primary" @click="sendMessage(1)">发送</a-button>
            </div>
        </div>

        <!--开播确定弹框-->
        <a-modal title="开启直播"
                 cancelText="取消"
                 okText="确认"
                 :confirmLoading="confirmLoading"
                 v-model="openLive" @ok="startLive">
            <p>确认开启直播？</p>
        </a-modal>
        <a-modal title="关闭直播"
                 cancelText="取消"
                 okText="确认"
                 :confirmLoading="confirmLoading"
                 v-model="closeLive" @ok="overLive">
            <p>确认关闭直播？</p>
        </a-modal>
        <!--图片modal弹层-->
        <a-modal
                title="图片"
                :visible="showImgMoudal"
                :footer="null"
                @cancel="showImgMoudal=false"
                @ok="showImgMoudal=true"
        >
            <p><img :src="imgFileUrl" alt="" style="width: 100%"></p>
        </a-modal>

    </div>


</template>
<script>
    import {startLive, overLive, liveCourseStatus, dictText, chatroomUploadFile} from "@api/course-live-online"
    import {createNamespacedHelpers} from "vuex";
    import common from "../../../mixin/common";
    import Loading from "@components/loading/Loading";
    import {SUCCESS} from "@constants/code";
    import {DISPATCH_INIT_CHAT_ROOM} from "@constants/action-type/chat-room-action-type";
    import {DISPATCH_LIVE_ONLINE_SWITCH_SECTION} from "@constants/action-type/course-live-online-action-type";
    import {showError, showMsg, showWaringMsg, showSuccessMsg} from "@utils/msg";
    import defaultCoverUrl from '../../../assets/img/默认封面图.jpg';
    //引入表情组件
    import {Picker} from "emoji-mart-vue";

    const {mapState} = createNamespacedHelpers('courseLiveOnline');
    const {mapState: umapStateUser} = createNamespacedHelpers('login');
    const {mapState: chatRoomMapState} = createNamespacedHelpers('chatRoom');

    export default {
        name: "CoursePlay",
        mixins: [common],
        components: {
            Loading,
            Picker,
            // Barrage
        },
        created() {
            this.defaultCoverUrl = defaultCoverUrl;
            // 获取课程id
            this.courseId = this.$route.params.courseId;
            this.username = this.userInfo.loginName;
            // 检测直播状态
            if (this.selectedSection.liveStatus === '1') {
                this.checkIsLive();
                this.liveStateIntervalId = setInterval(() => {
                    // 获取直播状态
                    this.checkIsLive();
                }, 3000);
            }
            dictText("live_cover_text").then((res) => {
                if (res.code === 0) {
                    if (!res.rows[0].dictLabel || res.rows[0].dictLabel == "") {
                        this.liveCoverText = "稍等，主播正在赶来的路上"
                    } else {
                        this.liveCoverText = res.rows[0].dictLabel
                    }
                } else {
                    this.liveCoverText = "稍等，主播正在赶来的路上"
                    // showError(res.msg)
                }
            })
        },
        mounted() {
            // 初始化直播间推流地址
            this.initPlayer();
            // 初始化推流地址
            this.$store.dispatch(DISPATCH_INIT_CHAT_ROOM, {courseId: this.courseId});
            //   获取屏幕宽高，确定弹幕宽度出现位置
            // 移动端计算屏幕高度
            if (this.isMobile) {
                this.barrageWidth = document.documentElement.clientHeight || document.body.clientHeight;
                //    确定下方高度
                this.discussionHeight = (this.barrageWidth - 380) + "px"
                //    检测页面高度变化
                window.onresize = () => {
                    console.log("312")
                    this.barrageWidth = document.documentElement.clientHeight || document.body.clientHeight;
                    //    确定下方高度
                    this.discussionHeight = (this.barrageWidth - 380) + "px"
                }
            } else {
                this.barrageWidth = document.documentElement.clientWidth || document.body.clientWidth;
            }

        },
        data() {
            return {
                defaultCoverUrl: null,
                //课程id
                courseId: 0,
                isShowOpen: true,
                //    消息内容
                content: "",
                //打开openLiveModal弹框
                openLive: false,
                closeLive: false,
                confirmLoading: false,
                height: "100px",
                discussionHeight: "100px",
                isLive: false,
                //封面图的字
                liveCoverText: "",
                //    显示手机端送花等图标
                showPhoneFlower: false,
                //    显示表情
                showPicker: false,
                showPhonePicker: false,

                //    控制上传头像
                // loading: false,
                // imageUrl: "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png",
                imageUrl: "",
                headers: {
                    authorization: 'authorization-text',
                },
                fileList: [],
                uploading: false,

                //    上传进度条
                showProgress: false,
                percent: 1,

                //    控制图片moudal层
                showImgMoudal: false,
                imgFileUrl: "",

                //    视频弹幕
                danmukuList: [],

                CM: null,
                //    弹幕宽度
                barrageWidth: 1000,
                //    切换tab
                activeKey: "1",
            }
        },
        computed: {
            fileUrl() {
                if (this.selectedSection.file)
                    return this.selectedSection.file.fileUrl;
                else
                    return ''
            },
            ...mapState({
                selectedSection: 'selectedSection',
                courseInfo: 'courseInfo',
                isLoadSection: 'isLoadSection',
                canStudyCourse: 'canStudyCourse',
                playM3u8Url: "playM3u8Url",
                playFlvUrl: "playFlvUrl",
                nextLiveSectionId: "nextLiveSectionId",
                isSignUp: "isSignUp",
                liveCoverUrl: "liveCoverUrl",
            }),
            ...umapStateUser({
                userInfo: "userInfo"
            }),
            ...chatRoomMapState({
                msgList: "msgList",
                socket: "socket",
                groups: "groups"
            }),
            groupUserList() {
                return this.groups;
            },
            // 直播播放地址
            livePlayUrl() {
                return this.isMobile ? this.playM3u8Url : this.playFlvUrl;
            },
            isLiveSwitch() {
                // console.log(this.userInfo.roles);
                if (this.userInfo.roles) {
                    for (let i = 0; i < this.userInfo.roles.length; i++) {
                        if (this.userInfo.roles[i].roleKey === "teacher" || this.userInfo.roles[i].roleKey === "admin") {
                            return true
                        } else {
                            return false
                        }
                    }
                }
                return false;
            }
        },
        methods: {
            sendDanMu() {
                // console.log(document.getElementsByClassName("ali-danmu-input")[0].children[0].value)
                let value = document.getElementsByClassName("ali-danmu-input")[0].children[0].value
                this.sendMessage(1, value);
                document.getElementsByClassName("ali-danmu-input")[0].children[0].value = ""
            },

            playVideo(sectionId, subsection) {
                //判断是否付费或报名
                if (!this.isSignUp) {
                    if (this.$func.isTrue(this.courseInfo.isFree))
                        showMsg("请先报名该课程！");
                    else
                        showMsg("抱歉，您尚未拥有该课程！");
                    return;
                }
                //    判断是否是直播，
                if (subsection.liveStatus === "0") {
                    // 尚未开播
                    showMsg("该课程尚未开播！")
                } else if (subsection.liveStatus === "1") {
                    // 正在直播
                    this.$store.dispatch(DISPATCH_LIVE_ONLINE_SWITCH_SECTION, {sectionId})
                } else if (subsection.liveStatus === "2" && subsection.isHaveVideo === "0") {
                    // 直播结束，没有回放
                    showMsg("该章节暂无回放！");
                } else if (subsection.liveStatus === "2" && subsection.isHaveVideo === "1") {
                    // 直播结束，有回放
                    this.$store.dispatch(DISPATCH_LIVE_ONLINE_SWITCH_SECTION, {sectionId})
                }
            },
            // 初始化直播间
            initPlayer() {
                // 判断地址是否为空
                if (!this.livePlayUrl) {
                    return;
                }
                const config = {
                    "id": "player-con",
                    "source": this.livePlayUrl,
                    "autoplay": true,
                    "isLive": true,
                    "rePlay": false,
                    "playsinline": true,
                    "preload": true,
                    // "controlBarVisibility": "click",
                    "useH5Prism": true,
                    "skinLayout": [
                        // {"name":"playButton","align":"tl","x":15,"y":12},//播放
                        {
                            "name": "bigPlayButton",
                            "align": "blabs",
                            "x": 30,
                            "y": 80
                        },
                        {
                            "name": "errorDisplay",
                            "align": "tlabs",
                            "x": 0,
                            "y": 0
                        },
                        {
                            "name": "infoDisplay"
                        },
                        {
                            "name": "controlBar",
                            "align": "blabs",
                            "x": 0,
                            "y": 0,
                            "children": [
                                {
                                    "name": "fullScreenButton",
                                    "align": "tr",
                                    "x": 10,
                                    "y": 10
                                },
                                {
                                    "name": "volume",
                                    "align": "tr",
                                    "x": 5,
                                    "y": 10
                                },
                                {
                                    "name": "playButton",
                                    "align": "tr",
                                    "x": 25,
                                    "y": 22
                                },
                            ]
                        }
                    ],
                    showBarTime: '10000',
                    //    弹幕配置
                    components: [{
                        name: 'AliplayerDanmuComponent',
                        // eslint-disable-next-line no-undef
                        type: AliPlayerComponent.AliplayerDanmuComponent,
                        args: [this.danmukuList]
                    }]
                };
                if (this.isMobile) {
                    config.width = '100%';
                    config.height = '180px';
                    config.controlBarVisibility = "click"
                } else {
                    config.controlBarVisibility = "click"
                    config.width = '900px';
                    config.height = "500px";
                }
                // eslint-disable-next-line no-undef
                this.player = new Aliplayer(config)
                // console.log(this.player.getComponent("AliplayerDanmuComponent").CM)
                this.CM = this.player.getComponent("AliplayerDanmuComponent").CM
                if (this.isMobile) {
                    this.CM.width = this.barrageWidth
                    this.CM.height = 180
                    this.CM.options.global.scale = 3;
                } else {
                    this.CM.width = this.barrageWidth
                    this.CM.height = 500
                    this.CM.options.global.scale = 5;
                }


                //    获取dom元素
                // console.log(document.getElementsByClassName("ali-danmu-input")[0].children[0].value)
                document.getElementsByClassName("danmu-input-enter")[0].onclick = () => {
                    this.sendDanMu()
                }
                document.getElementsByClassName("ali-danmu-input")[0].children[0].onkeydown = (event) => {
                    // console.log(event)
                    if (event.keyCode == "13") {
                        this.sendDanMu()
                    }
                }
            },
            //直播相关方法
            play() {
                this.player.play();
            },
            pause() {
                // console.log("暂停")
                this.player.pause();
            },
            replay: function () {
                // console.log("重播")
                this.player.replay();
            },
            reload: function () {
                // 修改source地址后
                // this.player.reloadPlayer();
                // this.isReload = true;
                // this.player.initAliplayer;
                // this.isReload = false;
                // this.player=null
                // this.initPlayer()
            },

            //    选择聊天
            changeTab(key) {
                // console.log(key)
                this.activeKey = key
                if (key && this.$refs.discussion) {
                    this.$nextTick(() => {
                        //在vue中操作dom尽量用ref, 但它不是响应式的
                        this.$refs.discussion.scrollTop = this.$refs.discussion.scrollHeight;
                    })
                }
            },
            //    开启直播
            openLiveModal() {
                this.openLive = true
            },
            startLive() {
                this.confirmLoading = true
                //传sectionId
                startLive(this.nextLiveSectionId).then((res) => {
                    if (res.code === SUCCESS) {
                        this.confirmLoading = false
                        this.openLive = false
                        // todo 放在vuex里的值
                        this.selectedSection.liveStatus = "1"
                        showSuccessMsg(res.msg)
                    } else {
                        this.confirmLoading = false
                        this.openLive = false
                        console.error(res.msg)
                    }
                })
            },
            //    关闭直播
            closeLiveModal() {
                this.closeLive = true
            },

            overLive() {
                this.confirmLoading = true
                //传sectionId
                overLive(this.nextLiveSectionId).then((res) => {
                    if (res.code === SUCCESS) {
                        this.confirmLoading = false;
                        this.closeLive = false;
                        this.selectedSection.liveStatus = "2";
                        showSuccessMsg(res.msg)
                    } else {
                        this.confirmLoading = false;
                        this.closeLive = false;
                        console.error(res.msg)
                    }
                })
            },

            //    聊天室 type = 1普通聊天，2点赞送花，3图片，4文件
            sendMessage(type, file) {
                this.activeKey = "1"
                if (this.isLoginClick()) {
                    this.msg = {
                        from: this.username,
                        createTime: new Date().getTime(),
                        cmd: 11,
                        group_id: this.courseId,
                        chatType: 1,
                        msgType: 0,
                        // content: this.content,
                        nickName: this.userInfo.nickname,
                        avatar: escape(this.userInfo.avatarUrl),
                    };
                    //    普通聊天
                    if (type === 1) {
                        if (file) {
                            this.msg.type = "1";
                            this.msg.content = file,
                                this.socket.send(JSON.stringify(this.msg));
                        } else {
                            if (this.content && this.content.trim()) {
                                this.msg.type = "1";
                                this.msg.content = this.content,
                                    this.socket.send(JSON.stringify(this.msg));
                                this.content = ""
                                this.showPicker = false
                                this.showPhonePicker = false
                            } else {
                                showMsg("请确认输入不为空！");
                            }
                        }

                    }
                    //送花，点赞
                    else if (type === 2) {
                        this.msg.type = "2";
                        this.msg.content = file
                        this.socket.send(JSON.stringify(this.msg));
                    } else if (type === 3) {
                        this.msg.type = "3";
                        this.msg.fileName = file.fileName;
                        this.msg.fileUrl = file.fileUrl;
                        this.socket.send(JSON.stringify(this.msg));
                    } else if (type === 4) {
                        this.msg.type = "4";
                        this.msg.fileName = file.fileName;
                        this.msg.fileUrl = file.fileUrl;
                        this.socket.send(JSON.stringify(this.msg));
                    }
                }
            },

            checkIsLive() {
                liveCourseStatus(this.courseId).then(res => {
                    // 是否直播
                    this.isLive = res;
                });
            },
            //选择表情
            addEmoji(e) {
                this.content += e.native;
            },
            //    上传文件
            //    改头像
            beforeUpload() {
                return false
            },
            //图片
            handleChangeImg(info) {
                // this.uploading = true;
                const isJPG = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
                if (!isJPG) {
                    showWaringMsg('抱歉，您只能发送JPG或PNG文件！');
                    return;
                } else {
                    const isLt2M = info.file.size / 1024 / 1024 < 1;
                    if (!isLt2M) {
                        showWaringMsg('抱歉，图片必须小于1MB！');
                        return
                    } else {
                        showMsg("图片上传中")
                        this.showProgress = true
                        let timer = setInterval(() => {
                            if (this.percent < 100) {
                                this.percent += 10
                            } else {
                                this.percent = 99
                            }
                        }, 100)
                        chatroomUploadFile(info.file, this.courseId).then((res) => {
                            if (res.code === 0) {
                                //    发图片消息
                                this.percent = 100
                                this.sendMessage(3, res.file)
                                showSuccessMsg("图片发送成功！")
                                clearInterval(timer);
                                this.percent = 1
                                this.showProgress = false
                            } else {
                                showError(res.msg)
                            }
                        })

                    }
                }
            },
            //文件
            handleChangeFile(info) {
                // console.log(info)
                // this.uploading = true;
                const isLt2M = info.file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    showWaringMsg('抱歉，文件必须小于1MB！');
                    return
                } else {
                    showMsg("图片上传中")
                    this.showProgress = true
                    let timer = setInterval(() => {
                        if (this.percent < 100) {
                            this.percent += 10
                        } else {
                            this.percent = 99
                        }
                    }, 100)
                    chatroomUploadFile(info.file, this.courseId).then((res) => {
                        if (res.code === 0) {
                            //    发文件消息
                            this.percent = 100
                            this.sendMessage(4, res.file)
                            showSuccessMsg("文件发送成功！")
                            clearInterval(timer);
                            this.percent = 1
                            this.showProgress = false
                        } else {
                            showError(res.msg)
                        }
                    })

                }
            },
            //点击图片放大
            openImg(fileUrl) {
                // console.log("32")
                if (this.isLoginClick()) {
                    this.showImgMoudal = true
                    this.imgFileUrl = fileUrl
                }
            },
        },
        watch: {
            selectedSection() {
                if (this.selectedSection.file) {
                    this.$refs.videoRef.src = this.selectedSection.file.fileUrl;
                    // this.$refs.videoRef.currentTime = this.selectedSection.sectionStudyLearnTime;
                }
            },
            "selectedSection.liveStatus"() {
                if (this.selectedSection.liveStatus === '1') {
                    clearInterval(this.liveStateIntervalId);
                    this.checkIsLive();
                    this.liveStateIntervalId = setInterval(() => {
                        // 获取直播状态
                        this.checkIsLive();
                    }, 3000);
                } else {
                    // 清理定时器
                    clearInterval(this.liveStateIntervalId);
                }
            },
            "$route"() {
                this.courseId = this.$route.params.courseId;
            },
            "livePlayUrl"() {
                this.initPlayer();
            },
            msgList() {
                // console.log(this.msgList);
                // console.log(this.groups);
                // todo 列表滑动到最后
                this.$nextTick(() => {
                    //在vue中操作dom尽量用ref, 但它不是响应式的
                    if (this.$refs.discussion)
                        this.$refs.discussion.scrollTop = this.$refs.discussion.scrollHeight;
                });
                //弹幕配置
                if (this.msgList && this.msgList.length > 0 && this.msgList[this.msgList.length - 1].type == "1") {
                    let a = {
                        "mode": 1,
                        "text": this.msgList[this.msgList.length - 1].content,
                        "stime": 0,
                        "size": 20,
                        "color": 0xffffff,
                        "ttl ": 80000000,
                        "dur ": 80000000
                    };
                    this.CM.send(a)
                }

            },

        },
        beforeDestroy() {
            // 关闭
            this.socket.close();
            // 清理定时器
            clearInterval(this.liveStateIntervalId);
        },

    }
</script>

<style scoped lang="less">

    .play-video-container {
        background: #333333;
        overflow: hidden;

        .video {
            display: inline-block;
            width: 860px;
            height: 500px;
            background-size: 900px 500px;
            position: relative;

            // 录播视频
            .video-play {
                width: 860px;
                height: 100%;
            }

            // 没有录播视频时显示
            .no-video {
                color: white;
                text-align: center;
                width: 1200px;
                height: 100%;
            }

            .no-video-live {
                width: 100%;
                padding: 0px;
            }

            > div {
                height: 100%;
                width: 100%;
                overflow: hidden;
                position: relative;
                background: #131313;
            }

            .not-permission-text {
                position: absolute;
                width: 100%;
                top: 50%;
                color: white;
                text-align: center;
            }
        }

        .chat-room-container {
            display: inline-block;
            float: right;
            width: 300px;
            height: 500px;
            /*height: 100%;*/
            overflow: auto;
            background: #333333;
            color: white;
            padding: 0 20px 10px 20px;
        }

        // 章节容器
        .sections-container {
            display: inline-block;
            width: 300px;
            height: 500px;
            overflow: auto;
            background: #131313;
            color: #999999;
            padding: 20px;

            .section-title {
                font-size: 18px;
                margin: 16px 0;
            }

            li {
                margin: 10px 0;
                cursor: pointer;

                .section-name {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                }

                .section-time {
                    text-indent: 44px;
                }
            }

            li:hover {
                color: #00CF8C;

                span:nth-of-type(1) {
                    background-color: #00CF8C;
                }
            }

            span:nth-of-type(1) {
                display: inline-block;
                font-size: 12px;
                line-height: 16px;
                padding: 1px 8px 2px 8px;
                color: white;
                text-align: center;
                background: #999999;
                border-radius: 2px;
            }
        }

        .sectio-mobile {
            display: inline-block;
            width: 100%;
            overflow: auto;
            background: #333333;
            color: white;
            padding: 0 20px;
        }

        .discussion-mobile::-webkit-scrollbar {
            display: none;
        }

        .discussion-mobile {
            color: white;
            overflow: auto;
            padding: 5px;

            li {
                margin: 10px 0
            }

            .logs-li {
                margin: 0;
                color: #999999;
            }

        }

        /*滚动条样式*/

        .chat-room-container::-webkit-scrollbar { /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
            width: 10px;
            height: 10px;
        }

        .sections-container::-webkit-scrollbar { /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
            width: 10px;
            height: 10px;
        }

        /*控制整个滚动条*/

        ::-webkit-scrollbar {
            background-color: lightgray;
            background-color: black;
            width: 10px;
            height: 10px;
            background-clip: padding-box;
        }

        /*滚动条两端方向按钮*/

        ::-webkit-scrollbar-button {
            /*background-color: pink;*/
            display: none;
        }

        /*滚动条中间滑动部分*/

        ::-webkit-scrollbar-thumb {
            background-color: #888888;
            border-radius: 4px;
        }

        /*滚动条右下角区域*/

        ::-webkit-scrollbar-corner {
            display: none;
        }
    }

    .player-control {
        span {
            color: #00CF8C;
            font-size: 26px;
            margin-left: 10px;
            margin-right: 10px;
        }
    }

    /deep/ .ant-tabs-nav-wrap {
        color: white;
    }

    .discussion {
        color: white;
        height: 340px;
        overflow: auto;
        padding: 5px;

        li {
            margin: 10px 0;

            dt:nth-of-type(1) {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .logs-li {
            margin: 0;
            color: #999999;
        }
    }

    .member {
        color: white;
        height: 340px;
        overflow: auto;
        padding: 5px;
    }

    .speak {
        margin-top: 4px;
    }

    .video-live-title {
        height: 60px;
        line-height: 60px;
        color: #999999;
        background-color: #1D1D1D;

        span {
            margin: 0 0 0 20px;
        }

        span:nth-of-type(1) {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 800px;
            white-space: nowrap;
        }

        .open-live-online {
            float: right;
            margin: 0 20px 0 0;
        }
    }

    .prism-player {
        width: 100%;
        height: 500px;
        position: absolute;
    }

    /deep/ .ant-tabs-tab {
        width: 50%;
        text-align: center;
        margin: 0 0 0 0;
    }

    /deep/ .ant-tabs-nav {
        width: 100%;
    }

    // 移动端样式
    .mobile-play-video-container {
        width: 100%;

        .play-video-container {
            background: #9999;
        }

        .mobile-loading {
            height: 200px;
        }

        .video-live-title {
            height: 40px;
            line-height: 40px;

            span:nth-of-type(1) {
                width: calc(100vw - 130px);
            }
        }

        .add, .sub {
            position: fixed;
            bottom: 50px;
            right: 10px;
            font-size: 16px;
            display: flex;
            justify-items: center;
            flex-direction: row;
            align-items: center;
            background: #1890ff;
            border-radius: 20px;
            padding: 12px;
            height: 39px;
            z-index: 100;

            img {
                height: 18px;
                margin-right: 10px;
                cursor: pointer;
                display: inline;
            }
        }

        .mobile-send-msg {
            display: flex;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 5px 10px;
            border-top: 1px solid #999999;
            background: #333333;
            z-index: 100;

            button {
                margin-left: 5px;
            }
        }

        .video {
            width: 100%;
            height: 180px;

            .no-video {
                height: 180px;
                width: 100%;
            }

            .video-play {
                width: 100%;
            }
        }

        .speak {
            position: relative;

            .picker {
                /*color: white!important;*/
                position: absolute;
                bottom: 10px;
                right: 10px;
                /*font-size: 22px;*/
                width: 250px;
                /*height: 400px;*/
                overflow: auto;
            }

            /deep/ .emoji-mart-scroll[data-v-7bc71df8] {
                width: 240px;
                height: 200px;
            }

            /deep/ .emoji-mart {
                width: 200px;
                height: 200px;
            }

            /deep/ .emoji-mart-category-label {
                display: none;
            }
        }
    }

    /*隐藏下载*/
    video::-internal-media-controls-download-button {
        display: none;
    }

    video::-webkit-media-controls-enclosure {
        overflow: hidden;
    }

    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }

    /deep/ .prism-player .prism-play-btn.playing {
        width: 90px;
        height: 90px;
        display: block;
        color: #FF4F23;
        background: url("//gw.alicdn.com/tps/TB1YuE3KFXXXXaAXFXXXXXXXXXX-256-512.png") no-repeat -2px -2px;
    }

    .player-control {
        span {
            color: #00CF8C;
            font-size: 26px;
            margin-left: 10px;
            margin-right: 10px;
        }
    }

    .no-video-live-text {
        position: absolute;
        font-size: 20px;
        top: 50%;
        left: 50%;
        text-align: center;
        transform: translate(-50%);
    }

    .sendAll {
        margin-top: 20px;
        position: relative;

        /*进度条*/

        .progress {
            position: absolute;
            top: 22px;
            left: 0px;
            width: 160px;
        }

        img {
            height: 18px;
            margin-right: 8px;
            cursor: pointer;
        }

    }

    /*    表情包*/
    .emoji-mart {
        font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
        color: #ffffff !important;
    }

    .speak {
        position: relative;

        .picker {
            position: absolute;
            bottom: 10px;
            right: 10px;
            width: 250px;
            overflow: auto;
        }

        /deep/ .emoji-mart-scroll[data-v-7bc71df8] {
            width: 240px;
            height: 200px;
        }

        /deep/ .emoji-mart {
            width: 200px;
            height: 200px;
        }

        /deep/ .emoji-mart-category-label {
            display: none;
        }
    }

    .phone-picker {
        position: absolute;
        bottom: 30px;
        right: 10px;
        width: 250px;
        overflow-y: auto;
        overflow-x: hidden;

        /deep/ .emoji-mart-scroll {
            width: 240px;
            height: 200px;
        }

        /deep/ .emoji-mart {
            width: 200px;
            height: 150px;
        }

        /deep/ .emoji-mart-category-label {
            display: none;
        }
    }

    /deep/ .emoji-mart-emoji {
        span {
            background-image: url("../../../assets/img/emoji.png") !important;
        }
    }

    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }

    .msg-a {
        color: #1ec5ef;
    }

    /deep/ .baberrage-stage {
        width: 100%;
    }

    /deep/ .ali-danmu-input .danmu-input-enter {
        height: 32px;
    }

    /*/deep/ body {*/
    /*    background: #232323;*/
    /*}*/
</style>
